import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';
import  'rxjs/add/operator/filter';

@Directive({
  selector: '[validate-onblur]',
  host: {
      '(focus)': 'onFocus($event)',
      '(blur)' : 'onBlur($event)'
  }
})
export class ValidateOnBlurDirective {

  private validators: any;
  private asyncValidators: any;
  private hasFocus = false;

  constructor(public formControl: NgControl) {
  }

  onFocus($event) {
    //console.log("OnFocus enter...:")
      this.hasFocus = true;
      this.validators = this.formControl.control.validator;
      this.asyncValidators = this.formControl.control.asyncValidator;
      this.formControl.control.clearAsyncValidators();
      this.formControl.control.clearValidators();
      this.formControl.control.valueChanges
          .filter(() => this.hasFocus)
          .subscribe(() => this.formControl.control.markAsPending());
  }

  onBlur($event) {
    //console.log("OnBlur enter...:")
      this.hasFocus = false;
      this.formControl.control.setAsyncValidators(this.asyncValidators);
      this.formControl.control.setValidators(this.validators);
      this.formControl.control.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/validate-on-blur.directive.ts